import { useApolloClient, useMutation } from '@apollo/client';
import { CustomRegionDeleteDocument, CustomRegionUpdateDocument, CustomRegionUploadDocument, FileHeaderFragmentDoc, useGetCustomRegionListLazyQuery as _useGetCustomRegionListLazyQuery, useGetCustomRegionListQuery as _useGetCustomRegionListQuery, } from '../generated/graphql-types';
export const useCustomRegionUploadMutation = () => {
    const [_uploadCustomRegion, { data, error, loading }] = useMutation(CustomRegionUploadDocument);
    return {
        data,
        error,
        loading,
        uploadCustomRegion: (file, mimeType, displayName, geometryType, orgId) => _uploadCustomRegion({
            variables: {
                file,
                mimeType,
                displayName,
                geometryType,
                orgId,
            },
        }),
    };
};
export const useCustomRegionUpdateMutation = () => {
    const [_updateCustomRegion, { data, error, loading }] = useMutation(CustomRegionUpdateDocument);
    return {
        data,
        error,
        loading,
        updateCustomRegion: (id, file, mimeType, displayName, geometryType, orgId) => _updateCustomRegion({
            variables: {
                id,
                file,
                mimeType,
                displayName,
                geometryType,
                orgId,
            },
        }),
    };
};
export const useGetCustomRegionListQuery = (orgId) => {
    const { data, error, loading } = _useGetCustomRegionListQuery({
        variables: { orgId },
    });
    return {
        error,
        loading,
        data: data?.getCustomRegionList,
    };
};
export const useGetCustomRegionListLazyQuery = (orgId) => {
    const [getCustomRegionList, { data, error, loading },] = _useGetCustomRegionListLazyQuery({
        fetchPolicy: 'network-only',
        variables: {
            orgId,
        },
    });
    return {
        getCustomRegionList,
        data: data?.getCustomRegionList,
        loading,
        error,
    };
};
export const useCustomRegionDeleteMutation = () => {
    const [_deleteCustomRegion, { data, error, loading }] = useMutation(CustomRegionDeleteDocument);
    return {
        data,
        error,
        loading,
        deleteCustomRegion: (id, orgId) => _deleteCustomRegion({
            variables: {
                id,
                orgId,
            },
        }),
    };
};
export const useGetCustomRegionFromCacheQuery = (id) => {
    const client = useApolloClient();
    return client.readFragment({
        id: client.cache.identify({ id, __typename: 'FileHeader' }),
        fragment: FileHeaderFragmentDoc,
    });
};
//# sourceMappingURL=chart-customization-service.js.map